import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'

import {
  NotificationsIcon,
  MyLeader,
  UserGuide,
  AssessorGuide,
  Image
} from 'containers/misc'
import { stack as Menu } from 'react-burger-menu'
import { push } from 'connected-react-router'
import { HeaderItem, CloseButton } from 'components/misc'
import { BurgerIcon } from 'components/layout'
import { getFullName, multipleOrganizations } from 'utils/token'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import config from 'config'
import styles from './burger-menu.styl'
import { AffiliationsOverviewModal, WWCStatusModal } from '../../modals'
import { AWARD_TYPES, LEVELS } from '../../../constants/enums'

@connect(
  ({ auth, api }) => ({
    user: auth.user,
    profile: api.dashboard.persons.profile
  }),
  {
    push
  }
)
@modal.trigger()
class BurgerMenu extends Component {
  static propTypes = {
    onOpen: PropTypes.func,
    push: PropTypes.func.isRequired,
    user: PropTypes.object,
    routeParams: PropTypes.object,
    indexRoute: PropTypes.string,
    awards: PropTypes.object,
    profile: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.name = getFullName(props.user)
    this.organization = get(props, 'user.organizationName')
    this.multipleOrganizations = multipleOrganizations(props.user)

    this.state = {
      isOpen: false
    }
  }

  redirectHome = () => {
    const { push, routeParams } = this.props

    if (routeParams && routeParams.awardId && !isNaN(routeParams.awardId)) {
      return push(`${config.publicPath}/dashboard/awards/${routeParams.awardId}`)
    }
    push(`${config.publicPath}/dashboard`)
  }

  redirectAssessorHome = () => this.props.push(`${config.publicPath}/assessor`)

  openProfileDetails = e => {
    this.props.onOpen(MODALS.PROFILE_DETAILS)
    this.handleMenuClick(e)
  }

  handleMenuClick = e => {
    e.preventDefault()
    this.setState({ isOpen: false })
  }

  openMajorActivityChange = () =>
    this.props.onOpen(MODALS.CHANGE_MAJOR_ACTIVITY)

  openWWCDialog = () => this.props.onOpen(MODALS.WWC_STATUS)

  openAffiliationsOverview = () => this.props.onOpen(MODALS.AFFILIATIONS_OVERVIEW)

  openSettings = () => this.props.onOpen(MODALS.SETTINGS)

  openAwardSummary = () =>
    this.props.push(this.props.indexRoute + '/award-summary')

  render() {
    const { awards, isAssessor, profile } = this.props
    const isSimplified = get(awards, 'awardType.value') === AWARD_TYPES.simplified.id
    const isBronze = get(awards, 'awardLevel.value') === LEVELS.BRONZE.id
    const isSimplifiedBronze = isSimplified && isBronze
    const showChangeMajor = get(awards, 'majorActivityNeeded') === true && !isAssessor && !isSimplifiedBronze

    return (
      <div className={styles.menu}>
        <Menu
          customBurgerIcon={<BurgerIcon />}
          customCrossIcon={<CloseButton />}
          isOpen={this.state.isOpen}
        >
          <div>
            <div className={styles.user} onClick={this.openProfileDetails}>
              <div className={styles.avatar}>
                {get(profile, 'data.photoUrl') && (
                  <Image
                    src={get(profile, 'data.photoUrl')}
                    className={styles.avatarImg}
                    alt="Profile picture"
                    width={30}
                    height={30}
                  />
                )}
                {!get(profile, 'data.photoUrl') && (
                  <span className={`ico ico--user ${styles.icoCustom} `} />
                )}
              </div>
              <p className={styles.personalInfo}>
                <span className={styles.name}>{this.name}</span>
                <span className={styles.organization}>{this.organization}</span>
              </p>
            </div>
          </div>

          {!isAssessor && (
            <div onClick={this.handleMenuClick}>
              <HeaderItem
                ico="icon-award"
                caption="My Award"
                captionKey="label.my_award"
                onClick={this.redirectHome}
                sizeUpIcon
              />
            </div>
          )}

          {isAssessor && (
            <div onClick={this.handleMenuClick}>
              <HeaderItem
                ico="icon-award"
                caption="Participants"
                captionKey="label.participants"
                onClick={this.redirectAssessorHome}
                sizeUpIcon
              />
            </div>
          )}

          {!isAssessor && (
            <div onClick={this.handleMenuClick}>
              <NotificationsIcon menuItem onlyTrigger />
            </div>
          )}

          {!isAssessor && (
            <div onClick={this.handleMenuClick}>
              <MyLeader onlyTrigger />
            </div>
          )}

          <div onClick={this.handleMenuClick}>
            {isAssessor ? (
              <AssessorGuide onlyTrigger />
            ) : (
              <UserGuide onlyTrigger />
            )}
          </div>

          {isAssessor && (<div onClick={this.openAffiliationsOverview}>
              <HeaderItem
                ico="subject"
                caption="Affiliations Overview"
                captionKey="label.affiliations_overview"
              />
              <AffiliationsOverviewModal modalId={MODALS.AFFILIATIONS_OVERVIEW} />
            </div>
          )}

          {isAssessor && (<div onClick={this.openWWCDialog}>
              <HeaderItem
                ico="file"
                caption="wwcStatus"
                captionKey="label.wwc_status"
              />
              <WWCStatusModal modalId={MODALS.WWC_STATUS} />
          </div>
          )}

          <div onClick={this.handleMenuClick}>
            <HeaderItem
              ico="icon-profile"
              caption="My Profile"
              captionKey="label.profile"
              onClick={this.openProfileDetails}
            />
          </div>

          <div onClick={this.handleMenuClick}>
            <HeaderItem
              ico="settings"
              caption="Settings"
              captionKey="label.settings"
              onClick={this.openSettings}
            />
          </div>

          {!isAssessor && (
            <div onClick={this.handleMenuClick}>
              <HeaderItem
                ico="icon-award"
                caption="Award Summary"
                captionKey="label.award_summary"
                onClick={this.openAwardSummary}
              />
            </div>
          )}

          {showChangeMajor && (
            <div onClick={this.handleMenuClick}>
              <HeaderItem
                ico="icon-transfer"
                caption="Change major activity"
                captionKey="label.change_major_activity"
                onClick={this.openMajorActivityChange}
              />
            </div>
          )}

          <div onClick={this.handleMenuClick} style={{ paddingTop: '20px' }}>
            <HeaderItem
              ico="logout"
              caption="Logout"
              captionKey="label.logout"
              onClick={this.redirectHome}
              link
              to={`${config.publicPath}/logout`}
            />
          </div>
        </Menu>
      </div>
    )
  }
}

export default BurgerMenu
